// UPDATED CODE
import React from "react";
import CustomizableAvatar from "../common/CustomizableAvatar";
import { useNavigate, useParams } from "react-router-dom";
import MainAvatar from "../../assets/main-avatar.png";
import Smartlend from "../../assets/SMARTLEND.png";
import { useState } from "react";
import { Link } from "react-router-dom";
import { CloseIcon, SkipIcon } from "../common/IconComponents";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "./ReusableFormik/FormikControl";
import axios from "axios";
import Loading from "../common/Loading";

const AddTeam = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [teamMembers, setTeamMembers] = useState([]);

  const dropDownOptions = [
    { key: "Select", value: "" },
    { key: "Admin", value: "Admin" },
    { key: "Analyst", value: "Analyst" },
  ];

  const initialValues = {
    firstname: "",
    lastname: "",
    email: "",
    permission: "",
    // invitedBy: "",
  };

  // validation
  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format").required("Required"),
    permission: Yup.string().required("Required"),
    firstname: Yup.string().required("Required"),
    lastname: Yup.string().required("Required"),
  });

  // Form submission
  const onSubmit = async (values, { resetForm }) => {
    // values["invitedBy"] = id;
    const newTeamMember = {
      firstname: values.firstname,
      lastname: values.lastname,
      email: values.email,
      permission: values.permission,
      // invitedBy: values.invitedBy,
    };

    setTeamMembers([...teamMembers, newTeamMember]);
    resetForm();
    console.log("FORM DATA", values);
    console.log(typeof values) // shows the values as objects, when she needs an object and id
  };

  const params = useParams();
  const id = params.id;

  // Make API request to submit team members data
  const submitToAPI = async () => {
    console.log("ADDED MEMBERS", { invitedBy: id, invitedUsers: teamMembers });
    try {
      setIsSubmitting(true);
      const response = await axios.post(
        "https://smartapp-lendbackend.onrender.com/api/admin/invite-teammember",
        { invitedBy: id, invitedUsers: teamMembers }
      );
      console.log("API response", response.data);
      navigate("/uploadLogo");
    } catch (error) {
      console.error("API error", error);
      alert(error.response.data);
    } finally {
      setIsSubmitting(false);
    }
  };

  // delete added team member
  const removeTeamMember = (index) => {
    const updatedTeamMembers = [...teamMembers];
    updatedTeamMembers.splice(index, 1);
    setTeamMembers(updatedTeamMembers);
  };

  return (
    <main>
      <section className="container my-0  mx-auto">
        <section>
          <div className=" p-4 px-4 md:p-8">
            <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
              <CustomizableAvatar src={MainAvatar} className="px-1" />

              <div className=" px-10 lg:col-span-2 py-5">
                <CustomizableAvatar src={Smartlend} />
                <p className="text-2xl pt-6">Add team member</p>

                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {(formik) => {
                    return (
                      <Form className="container w-9/12">
                        <FormikControl
                          control="input"
                          label="First name (required)"
                          type="text"
                          placeholder="e.g. Oluwatofunmi"
                          name="firstname"
                        />

                        <FormikControl
                          control="input"
                          label="Last name (required)"
                          type="text"
                          placeholder="e.g. Idowu"
                          name="lastname"
                        />

                        <FormikControl
                          control="input"
                          label="Work email address (required)"
                          type="email"
                          placeholder="e.g. idowu.oluwatofunmi9@gmail.com"
                          name="email"
                        />

                        <FormikControl
                          control="select"
                          label="Permission"
                          name="permission"
                          options={dropDownOptions}
                        />

                        {/* <FormikControl
                          control="input"
                          id="id"
                          value={id}
                          type="text"
                          hidden
                          name="invitedBy"
                        /> */}

                        <div className="flex items-center justify-between mt-6">
                          <button
                            type="submit"
                            className={`${!formik.values.teamMembers
                                ? "bg-disabled-btn text-disabled cursor-not-allowed"
                                : "bg-enabled-btn text-white hover:bg-indigo-600"
                              } py-2 px-14 rounded cursor-pointer `}
                            disabled={!formik.values}
                          >
                            Add team member
                          </button>
                          <Link
                            to={"/uploadLogo"}
                            className="flex items-center text-enabled-btn text-xs "
                          >
                            skip <SkipIcon className="pl-1" />
                          </Link>{" "}
                        </div>
                        <section className="mt-5">
                          {teamMembers.map((member, index) => (
                            <div
                              key={index}
                              className="border-admin-border border rounded  text-base py-1 px-5 mb-1 w-3/6 flex items-center justify-between"
                            >
                              <p className="hidden">
                                {member.firstname} {member.lastname}
                              </p>
                              <p>{member.email}</p>

                              <p className="hidden">{member.permission}</p>
                              <CloseIcon
                                className={"p-2 cursor-pointer"}
                                onClick={() => removeTeamMember(index)}
                              />
                            </div>
                          ))}
                        </section>
                        {teamMembers.length > 0 && (
                          <button
                            type="button"
                            className={`${teamMembers.length > 0
                                ? "bg-enabled-btn text-white hover:bg-indigo-600"
                                : "bg-disabled-btn text-disabled cursor-not-allowed"
                              } py-2 px-14 rounded mt-4`}
                            disabled={teamMembers.length === 0 || isSubmitting}
                            onClick={submitToAPI}
                          >
                            {isSubmitting ? (
                              <Loading
                                type="spinningBubbles"
                                color="#FFF"
                                height={20}
                                width={20}
                              />
                            ) : (
                              "Continue"
                            )}
                          </button>
                        )}
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
        </section>
      </section>
    </main>
  );
};

export default AddTeam;










//YOUR CODE UNTOUCHED
// import CustomizableAvatar from "../common/CustomizableAvatar";
// import { useNavigate, useParams } from "react-router-dom";
// import MainAvatar from "../../assets/main-avatar.png";
// import Smartlend from "../../assets/SMARTLEND.png";
// import { useState } from "react";
// import { Link } from "react-router-dom";
// import { CloseIcon, SkipIcon } from "../common/IconComponents";
// import { Formik, Form } from "formik";
// import * as Yup from "yup";
// import FormikControl from "./ReusableFormik/FormikControl";
// import axios from "axios";

// const AddTeam = () => {
//   const navigate = useNavigate();
//   const [teamMembers, setTeamMembers] = useState([]);

//   const dropDownOptions = [
//     { key: "Select", value: "" },
//     { key: "Admin", value: "Admin" },
//     { key: "Analyst", value: "Analyst" },
//   ];

//   const initialValues = {
//     firstname: "",
//     lastname: "",
//     email: "",
//     permission: "",
//     // invitedBy: "",
//   };

//   // validation
//   const validationSchema = Yup.object({
//     email: Yup.string().email("Invalid email format").required("Required"),
//     permission: Yup.string().required("Required"),
//     firstname: Yup.string().required("Required"),
//     lastname: Yup.string().required("Required"),
//   });

//   // Form submission
//   const onSubmit = async (values, { resetForm }) => {
//     // values["invitedBy"] = id;
//     const newTeamMember = {
//       firstname: values.firstname,
//       lastname: values.lastname,
//       email: values.email,
//       permission: values.permission,
//       // invitedBy: values.invitedBy,
//     };

//     setTeamMembers([...teamMembers, newTeamMember]);
//     resetForm();
//     console.log("FORM DATA", values);
//   };

//   const params = useParams();
//   const id = params.id;

//   // Make API request to submit team members data
//   const submitToAPI = async () => {
//     console.log("ADDED MEMBERS", { invitedBy: id, invitedUser: teamMembers });
//     try {
//       const response = await axios.post(
//         "https://smartapp-lendbackend.onrender.com/api/admin/invite-teammember",
//         { invitedBy: id, invitedUser: teamMembers }
//       );
//       console.log("API response", response.data);
//       navigate("/uploadLogo");
//     } catch (error) {
//       console.error("API error", error);
//       alert(error.response.data);
//     }
//   };

//   // delete added team member
//   const removeTeamMember = (index) => {
//     const updatedTeamMembers = [...teamMembers];
//     updatedTeamMembers.splice(index, 1);
//     setTeamMembers(updatedTeamMembers);
//   };

//   return (
//     <main>
//       <section className="container my-0  mx-auto">
//         <section>
//           <div className=" p-4 px-4 md:p-8">
//             <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
//               <CustomizableAvatar src={MainAvatar} className="px-1" />

//               <div className=" px-10 lg:col-span-2 py-5">
//                 <CustomizableAvatar src={Smartlend} />
//                 <p className="text-2xl pt-6">Add team member</p>

//                 <Formik
//                   initialValues={initialValues}
//                   validationSchema={validationSchema}
//                   onSubmit={onSubmit}
//                 >
//                   {(formik) => {
//                     return (
//                       <Form className="container w-9/12">
//                         <FormikControl
//                           control="input"
//                           label="First name (required)"
//                           type="text"
//                           placeholder="e.g. Oluwatofunmi"
//                           name="firstname"
//                         />

//                         <FormikControl
//                           control="input"
//                           label="Last name (required)"
//                           type="text"
//                           placeholder="e.g. Idowu"
//                           name="lastname"
//                         />
                      
//                         <FormikControl
//                           control="input"
//                           label="Work email address (required)"
//                           type="email"
//                           placeholder="e.g. idowu.oluwatofunmi9@gmail.com"
//                           name="email"
//                         />

//                         <FormikControl
//                           control="select"
//                           label="Permission"
//                           name="permission"
//                           options={dropDownOptions}
//                         />

//                         {/* <FormikControl
//                           control="input"
//                           id="id"
//                           value={id}
//                           type="text"
//                           hidden
//                           name="invitedBy"
//                         /> */}

//                         <div className="flex items-center justify-between mt-6">
//                           <button
//                             type="submit"
//                             className={`${
//                               !formik.values.teamMembers
//                                 ? "bg-disabled-btn text-disabled cursor-not-allowed"
//                                 : "bg-enabled-btn text-white hover:bg-indigo-600"
//                             } py-2 px-14 rounded cursor-pointer `}
//                             disabled={!formik.values}
//                           >
//                             Add team member
//                           </button>
//                           <Link
//                             to={"/uploadLogo"}
//                             className="flex items-center text-enabled-btn text-xs "
//                           >
//                             skip <SkipIcon className="pl-1" />
//                           </Link>{" "}
//                         </div>
//                         <section className="mt-5">
//                           {teamMembers.map((member, index) => (
//                             <div
//                               key={index}
//                               className="border-admin-border border rounded  text-base py-1 px-5 mb-1 w-3/6 flex items-center justify-between"
//                             >
//                               <p className="hidden">
//                                 {member.firstname} {member.lastname}
//                               </p>
//                               <p>{member.email}</p>

//                               <p className="hidden">{member.permission}</p>
//                               <CloseIcon
//                                 className={"p-2 cursor-pointer"}
//                                 onClick={() => removeTeamMember(index)}
//                               />
//                             </div>
//                           ))}
//                         </section>
//                         {teamMembers.length > 0 && (
//                           <button
//                             type="button"
//                             className={`${
//                               teamMembers.length > 0
//                                 ? "bg-enabled-btn text-white hover:bg-indigo-600"
//                                 : "bg-disabled-btn text-disabled cursor-not-allowed"
//                             } py-2 px-14 rounded mt-4`}
//                             disabled={teamMembers.length === 0}
//                             onClick={submitToAPI}
//                           >
//                             Continue
//                           </button>
//                         )}
//                       </Form>
//                     );
//                   }}
//                 </Formik>
//               </div>
//             </div>
//           </div>
//         </section>
//       </section>
//     </main>
//   );
// };

// export default AddTeam;
